import React from "react";
import "./Popup.css";
import { InputField } from "../";

const Popup = ({ title, subtitle, handleClose, handleConfirm, singleBtn = false, cancelLabel = "Cancel", confirmLabel = "OK" }) => {
    return (
        <div className="popup-overlay">
            <div className="popup-box">
                <div className="popup-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100"
                        height="100"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#750F35"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 16v-4"></path>
                        <path d="M12 8h.01"></path>
                    </svg>
                </div>
                <p className={"title"}>{title}</p>
                <p className={"subtitle"}>{subtitle}</p>
                <div className="popup-buttons">
                    {!singleBtn ??
                        <button id="popup-btn-cancel" onClick={handleClose}>{cancelLabel}</button>
                    }
                    <button id="popup-btn-confirm" onClick={handleConfirm}>{confirmLabel}</button>
                </div>
            </div>
        </div>
    );
};

export default Popup;